import { AxiosInstance } from 'axios';
import { BaseService } from 'yellowfin-ui-lib';

export class DownloadService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	download(id: string): Promise<Blob> {
		return this.mapResponse(this.http.get(`/ws/download/x/${id}`, { responseType: 'blob' }));
	}

	downloadThumb(id: string, size: string): Promise<Blob> {
		return this.mapResponse(this.http.get(`/ws/download/x/${id}/${size}`, { responseType: 'blob' }));
	}

	getProductVideoURL(id: string) {
		return `/ws/download/video/${id}`;
	}

	getProductVideothumbURL(id: string) {
		return `/ws/download/x/${id}/md`;
	}

}